/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_How_To_Play_TitleInputs */



/**
* | output |
* | --- |
* | "How to Play Riftbound" |
*
* @param {Help_Article_How_To_Play_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_how_to_play_title = /** @type {((inputs?: Help_Article_How_To_Play_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_How_To_Play_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Riftbound spielen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment jouer à Riftbound")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("如何玩 Riftbound")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("Riftbound 怎麼玩")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Riftbound 플레이 방법")
	return /** @type {LocalizedString} */ ("How to Play Riftbound")
});